<template>
  <div class="page-wrap page-show-condition">
    <jw-modal v-model:visible="data.visible" :title="title" title-align="start" width="760px" unmount-on-close>
      <template #title> {{ title }} </template>
      <template #footer>
        <jw-space v-if="!loading">
          <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
          <jw-button type="primary" @click="handleOk">{{ $t('确定') }}</jw-button>
        </jw-space>
      </template>
      <!-- jiaxiuc 替换为公共筛选条件组件 Start-->
      <template v-if="isShowConditions">
        <qf-condition-ultra ref="fieldCondition" :entities="entitiesList" :accCondition="conditionList" :allEntityFields="allEntityFieldsList" :filterId="filterId" :parentEntityId="props.source == 'tableLevel' ? parentBusinessDataCmp : pId" :showFooter="false" @cb="getConditions" />
      </template>
      <jw-spin v-else :loading="loading" style="width: 100%">
        <fh-custom-search-ultra ref="customFieldConditionRef" :parentEntityId="props.source == 'tableLevel' ? parentBusinessDataCmp : pId" :entity="data.entity" :conditions="data.conditions?.children" :showDefaultCondition="true" :showFooter="false" :noStyle="true" @clearAll="clearAllCondition" :maxHeight="500" :roleOutFieldTypes="[27]" :headerTitle="$t('条件配置')"> </fh-custom-search-ultra>
      </jw-spin>
    </jw-modal>
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import { Message } from '@arco-design/web-vue';
import { useRoute } from 'vue-router';
// import { publicService } from '@/api/';
import getLayoutFields from '@/hooks/layout';
const { isDeepEmptyCondition } = getLayoutFields();
// import useLoading from '@/hooks/loading';
// const { loading, setLoading } = useLoading(false);
// import useUpdateFields from '@/hooks/update-fields';

import { useI18n } from 'vue-i18n';
import useLoading from '@/hooks/loading';
const { t } = useI18n();
// const { initConditionFilter } = useUpdateFields();
const { loading, setLoading } = useLoading(false);

const route = useRoute();
// const router = useRouter();
const props = defineProps({
  conditions: {
    //分组的数量
    type: Array,
    default: () => []
  },
  parentBusinessData: {
    //多层级表格时上传，因为一级和二级三级有关系
    type: [String, Number],
    default: ''
  },
  source: {
    //来源 tableLevel:多层级表格
    type: String,
    default: () => ''
  },
  entity: {
    // 对象Id
    type: String,
    default: ''
  }
});

const parentBusinessDataCmp = computed(() => props.parentBusinessData);

const pId = ref(route.params?.id ? route.params.id : props.entity ? props.entity : '101');
//const pId = window.location.href.includes('/sys-fields/') ? window.location.href.split('/sys-fields/')[1].split('/')[0] : '101';
const fieldCondition = ref();
const customFieldConditionRef = ref();
console.log('1-开始创建组件-setup');
const emits = defineEmits('cb');

const updateConditions = computed(() => props.conditions);
const data = reactive({
  conditionVisible: false,
  visible: false,
  detailsTitle: '', //标题
  // isDisabled: false,
  entity: null,
  conditions: updateConditions.value //要提交的数据条件
});
const title = ref(t('添加显示条件'));
const isShowConditions = ref(false); // 是否显示条件

const handleCancel = () => {
  data.conditions = null;
  data.entity = null;
  data.visible = false;
};

// 组件回传
const getConditions = (record) => {
  console.log('回传数据：', record);

  data.conditions = {
    children: record
  };
};
// const allFields = ref([]);

// const getAllEntityFields = async () => {
//   try {
//     const res = await publicService.getAllEntityFields();
//     if (!res.error) {
//       allFields.value = res.result;
//     } else {
//       Message.error(res?.msg || res?.error?.msg || t('获取数据失败'));
//     }
//   } catch (e) {
//     console.log(e);
//   }
// };

// 清空条件
const clearAllCondition = () => {
  data.conditions.children = [];
};

// 新组件参数
const entitiesList = ref([]);
const conditionList = ref([]);
const filterId = ref('');
const allEntityFieldsList = ref([]);

const open = async (params, type, entity) => {
  console.log(200, params, type, entity);
  // type=1:显示条件，type=2数据条件范围配置；type=3添加必填条件
  if (type == 1) {
    title.value = t('添加显示条件');
  } else if (type == 2) {
    title.value = t('添加必填条件');
  } else if (type == 3) {
    title.value = t('数据范围条件配置');
    isShowConditions.value = true;
    console.log(216, entity);
  }

  data.entity = Number(entity || pId);
  data.visible = true;

  if (isShowConditions.value) {
    setLoading(true);

    let copyConditions = null;
    // if (allFields.value.length === 0) {
    //   await getAllEntityFields();
    //   console.log(getAllEntityFields);
    // }
    if (params) {
      data.conditions = [];
      data.conditions = JSON.parse(JSON.stringify(params));
      copyConditions = data.conditions?.children ? data.conditions.children : null;
      // copyConditions = initConditionFilter(copyConditions, allFields.value, data.entity);
      // console.log('初始化条件222', copyConditions)
    }

    console.log('初始化条件之后4444', props, entitiesList.value);
    // eslint-disable-next-line no-debugger
    // debugger;

    const currentEntity = props.source == 'tableLevel' ? Number(parentBusinessDataCmp.value) : Number(pId.value);

    entitiesList.value = [currentEntity, data.entity];
    conditionList.value = copyConditions;
    filterId.value = currentEntity;
    console.log('初始化条件之后3333', entitiesList.value);
    data.conditionVisible = true;

    // data.visible && fieldCondition.value.initFn(entitiesList.value, conditionList.value, filterId.value, true, allEntityFieldsList.value); //初始化数据

    setLoading(false);
  } else {
    if (params) {
      data.conditions = [];
      data.conditions = JSON.parse(JSON.stringify(params));
    }
  }
};
// ------------------------------------------------------------------------------------------
//添加
const handleOk = async () => {
  updateSettingField();
};
// 编辑接口
const updateSettingField = async () => {
  if (!data.conditions) {
    data.conditions = {};
    return;
  }
  if (!isShowConditions.value) {
    //高级筛选
    const resultConditions = await customFieldConditionRef.value.getAllConditions();
    if (!resultConditions) {
      return;
    }
    data.conditions.children = resultConditions;
  } else {
    //条件筛选
    const resultConditions = await fieldCondition.value.getAllConditions();
    if (!resultConditions) {
      return;
    }
    data.conditions.children = resultConditions;
  }
  const conditions = {
    operation: 'or',
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    children: data.conditions?.children || []
  };
  const condition = isDeepEmptyCondition(conditions);
  if (condition === null) {
    Message.warning(t('数据条件设置不可为空'));
  } else {
    handleCancel();
    console.info('回传数据：', condition);
    emits('cb', condition);
  }
};

// 初始化获取字段列表
onMounted(async () => {
  // await getFilter();
  // await getAllEntityFields();
});
// ------------------------------------------------------------------------------------------
defineExpose({ open });
</script>
<style scoped lang="less">
@import './show-condition.less';
</style>
